import React from "react";

export type RFProfileGroupItem = {
  SRFProfileGroupId: number | string;
  SRFProfileGroupName: string;
  TenantId: number | string;
  TenantName: string;
  SRFProfileGroupDetails?: string;
  created_by: string;
  created_date: string | Date;
  modified_by: string;
  modified_date: string | Date;
};

function formatDate(d: string | Date) {
  try {
    const date = typeof d === "string" ? new Date(d) : d;
    if (Number.isNaN(date.getTime())) return String(d);
    return date.toLocaleString();
  } catch {
    return String(d);
  }
}

function formatDateShort(d: string | Date) {
  try {
    const date = typeof d === "string" ? new Date(d) : d;
    if (Number.isNaN(date.getTime())) return String(d);
    return date.toLocaleDateString(undefined, {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  } catch {
    return String(d);
  }
}

function hasValue(v: any) {
  return v !== null && v !== undefined && String(v).trim() !== "";
}

function equalDateTime(a: string | Date, b: string | Date) {
  try {
    const da = typeof a === "string" ? new Date(a) : a;
    const db = typeof b === "string" ? new Date(b) : b;
    if (Number.isNaN(da.getTime()) || Number.isNaN(db.getTime())) {
      return String(a) === String(b);
    }
    return da.getTime() === db.getTime();
  } catch {
    return String(a) === String(b);
  }
}

export function renderRFProfileGroupItem(item: RFProfileGroupItem) {
  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full items-center gap-2">
        <div className="flex items-center gap-2 min-w-0 flex-wrap">
          <span
            className={`inline-block h-3 w-3 rounded-full ${
              ((item as any)?.IsActive ?? true) ? "bg-green-500" : "bg-red-500"
            }`}
            aria-label={
              ((item as any)?.IsActive ?? true) ? "Active" : "Inactive"
            }
            title={((item as any)?.IsActive ?? true) ? "Active" : "Inactive"}
          />
          <div className="truncate text-lg font-semibold text-foreground">
            {item.SRFProfileGroupName}
          </div>
          <span className="inline-flex items-center rounded-full border border-sky-200 bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-300 px-2 py-0.5 text-xs font-medium">
            {item.TenantName}
          </span>
        </div>
      </div>
      {item.SRFProfileGroupDetails ? (
        <div className="mt-2 line-clamp-2 text-base text-muted-foreground">
          {item.SRFProfileGroupDetails}
        </div>
      ) : null}
    </div>
  );
}

export default renderRFProfileGroupItem;
